import {Component, Input, OnInit} from '@angular/core';

import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-search-tree-view',
  templateUrl: './search-tree-view.component.html',
  styleUrls: ['./search-tree-view.component.css']
})
export class SearchTreeViewComponent implements OnInit {
  @Input() title: string = this.languageService.LNG('Label.Search');
  @Input() margintop = 0;
  @Input() hideTitle = false;
  @Input() menu: any[];

  @Input() hasClassTabDetailsLeft = true;
  classTabDetailsLeft = 'tab-details-left';
  menuItems: any[];


  constructor(public languageService: LanguageService) {
    this.menuItems = menuItems;

  }

  ngOnInit(): void {
  }

  selectItem($event: any) {
    console.log("selectItem", $event);
  }
}

export class Menu {
  id: string;
  text: string;
  expanded?: boolean;
  items?: Menu[];
}

const menuItems: Menu[] = [{
  id: '1_1',
  text: 'Type',
  expanded: true,
  items: [{
    id: '1_1_1',
    text: 'Su-tegning',
  }, {
    id: '1_1_2',
    text: 'Monteringsanvisning',
  }]},
  {
    id: '1_2',
    text: 'Category',
    expanded: true,
    items: [{
      id: '1_2_1',
      text: 'PDF',
    }, {
      id: '1_2_2',
      text: 'Word',
    }, {
        id: '1_2_3',
        text: 'Media',
      }]
  },
  {
    id: '1_3',
    text: 'Codes',
    expanded: true,
    items: [{
      id: '1_3_1',
      text: 'X4',
    }, {
      id: '1_3_2',
      text: 'X5',
    }, {
        id: '1_3_3',
        text: 'X6',
      }]
  }];

